import { CheckCircle2 } from "lucide-react";

export const Phase3Intro = () => {
  return (
    <div className="flex items-center gap-3 py-2">
      <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-primary/20 to-primary/5 flex items-center justify-center shrink-0">
        <CheckCircle2 className="h-5 w-5 text-primary" />
      </div>
      <div>
        <h2 className="text-xl font-semibold tracking-tight">Optionen bewerten</h2>
        <p className="text-sm text-muted-foreground">
          Passe die Werte an, wo du anderer Meinung bist – dauert 30 Sekunden.
        </p>
      </div>
    </div>
  );
};
